module.exports = __webpack_public_path__ + "img/gprPreview.58d1855d.jpg";